<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2023-07-05 16:31:19
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-04 15:13:17
 * @FilePath: \partner.chaoyongtuan.com\src\views\shopManage\selectionDecoration\list\components\tableCells\titleCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="statusCell yx-color-pure-1">
		<el-switch v-model="row.isPull" @change="change" active-value="1" inactive-value="0" inactive-color="#E2E3E8"> </el-switch>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
import { setGatherPage, setShowCase, setBanner, setIcons } from '@/api/selectionDecoration';
export default {
	mixins: [mixin],
	data() {
		return {};
	},
	inject: {
		refresh: {
			default: () => {},
		},
	},
	methods: {
		async change(val) {
			this.row.isPull = this.row.isPull === '1' ? '0' : '1';
			const { id, activeName, platformId } = this.row;
			// 如果是集合页要判断关联资源位
			if (activeName === '4') {
				if (this.row.linkCount && val === '0') {
					return this.$message.error('关联资源位大于0，不可以关闭集合页');
				}
			}
			const api = {
				1: setBanner,
				2: setIcons,
				3: setShowCase,
				4: setGatherPage,
			};
			await api[this.row.activeName]({ id, isPull: val, platformId, tplType: activeName === '3' ? this.row.type : undefined });
			this.row.isPull = this.row.isPull === '1' ? '1' : '0';
			this.$message.success('操作成功');
			// this.row.operations.getList();
			this.refresh();
		},
	},
};
</script>
<style lang="less" scoped></style>
